module.exports = __webpack_public_path__ + "media/footer/email-56588dc6.svg";